import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
require('./SubstitutionOptionCard.scss');

const initialState = {
  showAllVariants: false,
}

class SubstitutionOptionCard extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  render() {
    const { showAllVariants } = this.state;
    const {
      onSelect,
      variantList,
      selectedProduct: { id: selectedProductId },
      isOriginalProduct
    } = this.props;

    const variants = showAllVariants ? variantList : [variantList[0]];

    return (
      <div className={cx("SubstitutionOptionCard", { 'originalProduct': isOriginalProduct })}>
        <div className="substituteVariantList">
          {variants.map((product, index) => (<li
            key={index}
            className={cx('substituteVariant', { 'selected': product.id === selectedProductId })}
            onClick={() => onSelect(product)}
          >
            <input type="radio" checked={product.id === selectedProductId} />
            <div className="productInfo">
              {product.is_generic && <span className="recommended">Recommended</span>}
              <div className="productName">{product.name}</div>
              <div className="brandName">{product.manufacturer_name || product.consumer_brand || '---'}</div>
              {isOriginalProduct && <div className="originalProductTag">ORIGINAL PRODUCT</div>}
            </div>
            <div className="packform">{product.subtitle}</div>
            <div className="priceInfo">
              <div className="price">₹{product.discounted_mrp || product.curated_mrp || '---'}</div>
              {Boolean(product.difference) && (<div
                className={`diff ${product.difference > 0 ? 'expensive' : 'cheap'}`}
              >
                {Number(Math.abs(product.difference)).toFixed(2)}%
              </div>)}
            </div>
          </li>))}
        </div>
        {variantList.length > 1 && (<div className="toggleVariantList">
          <button onClick={() => this.setState({ showAllVariants: !showAllVariants })}>{showAllVariants ? 'Hide Options' : 'Show Options'}</button>
        </div>)}
      </div>
    );
  }
}

SubstitutionOptionCard.propTypes = {
  onSelect: PropTypes.func.isRequired,
  variantList: PropTypes.array.isRequired,
  selectedProduct: PropTypes.object,
  isOriginalProduct: PropTypes.bool,
};

SubstitutionOptionCard.defaultProps = {
  selectedProduct: {},
  isOriginalProduct: false,
}

export default SubstitutionOptionCard;
